import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface BagAction {
  collection: string;
  value: unknown;
}

interface ReportTableState {
  orderBag: Record<string, unknown>;
  orderByBag: Record<string, unknown>;
  pageIndexBag: Record<string, unknown>;
  rowsBag: Record<string, unknown>;
  rowCountBag: Record<string, unknown>;
  [key: string]: Record<string, unknown>;
}

const initialState: ReportTableState = {
  orderBag: {},
  orderByBag: {},
  pageIndexBag: {},
  rowsBag: {},
  rowCountBag: {},
};

export const inventoryReportsSlice = createSlice({
  name: 'reportTable',
  initialState,
  reducers: {
    setOrderBag(state, action: PayloadAction<BagAction>) {
      const { collection, value } = action.payload;
      state.orderBag[collection] = value;
    },
    setOrderByBag(state, action: PayloadAction<BagAction>) {
      const { collection, value } = action.payload;
      state.orderByBag[collection] = value;
    },
    setPageIndexBag(state, action: PayloadAction<BagAction>) {
      const { collection, value } = action.payload;
      state.pageIndexBag[collection] = value;
    },
    setRowsBag(state, action: PayloadAction<BagAction>) {
      const { collection, value } = action.payload;
      state.rowsBag[collection] = value;
    },
    setRowCountBag(state, action: PayloadAction<BagAction>) {
      const { collection, value } = action.payload;
      state.rowCountBag[collection] = value;
    },
  },
  extraReducers: (_builder) => {},
});

export const {
  setOrderBag,
  setOrderByBag,
  setPageIndexBag,
  setRowsBag,
  setRowCountBag,
} = inventoryReportsSlice.actions;

export default inventoryReportsSlice.reducer;
